import request, { adminForm } from '@/api/request'
import type { InvitationRow, InvitationSettlementRow, SpringPage } from '@/api/types/domain'

export function fetchInvitations(keyword?: string, page = 0, size = 15) {
  return request.get<SpringPage<InvitationRow>>('/api/admin/backoffice/invitations', {
    params: { ...(keyword ? { keyword } : {}), page, size },
  })
}

export interface SettlementQuery {
  keyword?: string
  start?: string
  end?: string
  page?: number
  size?: number
}

export function fetchInvitationSettlement(q: SettlementQuery) {
  const { keyword, start, end, page = 0, size = 25 } = q
  return request.get<SpringPage<InvitationSettlementRow>>('/api/admin/backoffice/invitations/settlement', {
    params: {
      ...(keyword ? { keyword } : {}),
      ...(start ? { start } : {}),
      ...(end ? { end } : {}),
      page,
      size,
    },
  })
}

export function addInvitation(salesperson: string) {
  return request.post<{ status?: number; msg?: string }>(
    '/api/admin/backoffice/invitations',
    adminForm({ salesperson }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } }
  )
}

export function deleteInvitation(id: number) {
  return request.delete<{ status?: number; msg?: string }>(`/api/admin/backoffice/invitations/${id}`)
}
